import { useMemo } from "react";
import { useApiContext } from "../components/api/ApiContext";
import PublicTransportService from "../services/PublicTransportService";

const usePublicTransportService = () => {
  const { client } = useApiContext();
  const service = useMemo(() => {
    return new PublicTransportService(client);
  }, [client]);

  return service;
};

export default usePublicTransportService;
